<template lang="html">
  <b-row id="filterApplied">
    <b-col class="text-center" cols="8" offset-md="2">
      <h3>OIG Recommendations</h3>
      <p>The Office of the Inspector General safeguards the integrity of the State's correctional system by providing oversight and transparency through monitoring, reporting, and recommending improvements to the California Department of Corrections and Rehabilitation.</p>
      <p>Filtered Recommendations: {{filteredRecommendations.length}}</p>
      <p class="font-italic" style="width: 100%; font-size: 0.8em;" v-if="Object.keys(this.reportFilter).length"><b>Filter(s) Applied:</b>
        <ul style="padding-inline-start: 0">
          <li v-for="(value,label) in this.reportFilter">{{displayFormat(label)}}: {{convertValue(label,value)}}</li>
        </ul>
      </p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ['reportFilter', 'filteredRecommendations'],
  methods: {
    displayFormat: function(text) {
      text = text.replace(/([A-Z])/g, ' $1')
      text = text.charAt(0)
        .toUpperCase() + text.slice(1)
      return text
    },
    convertValue: function(label, value) {
      let displayValues = []
      if (label === 'reportingPeriod') {
        value.forEach((x, y) => {
          this.data.reportingPeriods.filter(r => {
            if (r.value === x) displayValues[y] = r.text
          })
        })
        if (typeof displayValues !== 'undefined' && displayValues !== null)
          return displayValues.join(', ')
      } else if (typeof value !== 'undefined' && value !== null) {
        return value.join(', ')
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
